/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Col, Form, Input, Modal, Row, Tree } from 'antd';
import emiter, {EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST, EVENT_CARRENTAL_ROLE_OPEN_DETAIL} from '../../../../events';
import { getRoleFeatures } from '../../../../hooks/carRental/employee';

interface PropsType {
	enums?: any;
}

const SPRolePermissionsModal: React.FC<PropsType> = props => {
	const [mainForm] = Form.useForm();

	const [open, setOpen] = useState(false);
	const [treeData, setTreeData] = useState([]);
	const [appTreeData, setAppTreeData] = useState([]);
	const [expandedKeys, setExpandedKeys] = useState([]);
	const [appExpandedKeys, setAppExpandedKeys] = useState([]);

	const mainFormFields = {
		juesemingcheng: {
			name: 'user_name',
			label: '角色名称',
		},
		PCquanxian: {
			name: 'pc',
			label: 'PC权限',
		},
		APPquanxain: {
			name: 'app',
			label: 'APP权限',
		},
	};

	const getAllKeys = (data: any) => {
		let keys: any = [];
		data.forEach((itemKey: any) => {
			keys.push(itemKey.key);
			if (itemKey.children) {
				keys = keys.concat(getAllKeys(itemKey.children));
			}
		});
		return keys;
	};

	const closeModal = () => {
		setOpen(false);
		mainForm.resetFields();
	};

	const openModal = (data: any) => {
		setOpen(true);
		mainForm.setFieldsValue({
			user_name: data.name,
		});
		getRoleFeatures({ role_code: data.code }).then((res: any) => {
			const pcData: any = [];
			const appData: any = [];
			if (res?.data && res?.data.length) {
				res.data.forEach((item: any) => {
					if (item.app_tag) {
						appData.push(item);
					} else {
						pcData.push(item);
					}
				});
			}
			const allKeys = getAllKeys(pcData);
			setExpandedKeys(allKeys);
			const allAppKeys = getAllKeys(pcData);
			setAppExpandedKeys(allAppKeys);
			setTreeData(pcData);
			setAppTreeData(appData);
		});
	};

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_ROLE_OPEN_DETAIL, openModal);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_ROLE_OPEN_DETAIL)
		}
	}, []);

	const itemstyle: React.CSSProperties = { border: '1px solid #f0f0f0', borderRadius: '3px' };

	return (
		<Modal title="角色详情" centered width="60%" open={open} onCancel={closeModal} footer={null}>
			<Form form={mainForm} labelCol={{ span: 3 }} disabled>
				<Form.Item name={mainFormFields.juesemingcheng.name} label={mainFormFields.juesemingcheng.label}>
					<Input />
				</Form.Item>
				<Row gutter={24}>
					<Col span={10} style={itemstyle}>
						<div>PC权限：</div>
						<Form.Item name={mainFormFields.PCquanxian.name}>
							<Tree
								disabled
								defaultExpandAll
								treeData={treeData}
								expandedKeys={expandedKeys}
								onExpand={(keys: any) => setExpandedKeys(keys)}
								fieldNames={{ title: 'name', key: 'key', children: 'children' }}
							/>
						</Form.Item>
					</Col>
					<Col span={4} />
					<Col span={10} style={itemstyle}>
						<div>APP权限：</div>
						<Form.Item name={mainFormFields.APPquanxain.name}>
							<Tree
								disabled
								defaultExpandAll
								treeData={appTreeData}
								expandedKeys={appExpandedKeys}
								onExpand={(keys: any) => setAppExpandedKeys(keys)}
								fieldNames={{ title: 'name', key: 'key', children: 'children' }}
							/>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default SPRolePermissionsModal;
